import { z } from 'zod'

import { afterValid } from '~/services/api/contracts/afterValid'
import { email } from '~/services/api/contracts/email'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { phone } from '~/services/api/contracts/phone'
import { AcceptPartnerUserInviteRequestSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'
import { refinePasswordConfirmation } from '~/services/api/contracts/refinePasswordConfirmation'

const normalize = fieldNormalizer({
  trimmed: ['email', 'token', 'name', 'last_name'],
  blankToNull: ['phone', 'timezone']
})

const PartnerUserInvitationAcceptSchema = AcceptPartnerUserInviteRequestSchema.extend({
  email: email(255),
  password_confirmation: z.string().min(1),
  phone: phone.nullish()
}).strict()

export const PartnerUserInvitationAccept = (_context: NoContext = {}) =>
  z.preprocess(normalize, afterValid(PartnerUserInvitationAcceptSchema, refinePasswordConfirmation))
